<script lang="ts">
  import { run } from 'svelte/legacy';

  import {onMount} from "svelte";
  import Button from "$lib/elements/Button.svelte";
  import BonusOffers from "$lib/components/ModalContents/DepositWithdraw/Deposit/BonusOffers.svelte";
  import type {IPaymentOption} from "$lib/interfaces/IPaymentOption";
  import {paymentService} from "$lib/services/payment.service";

  interface Props {
    selectedPaymentOption: IPaymentOption;
  }

  let { selectedPaymentOption }: Props = $props();

  let payment: any = $state({
    amount: '',
    currency: 'EUR',
    locale: 'en',
    additionalFields: {}
  })

  run(() => {
    payment.currency = selectedPaymentOption.currencies.filter(currency => currency.currencyName === 'EUR')[0].currencyName;
  });

  let selectedCurrency = selectedPaymentOption.currencies.filter(currency => currency.currencyName === 'EUR')[0];
  let currencies = selectedPaymentOption.currencies;
  let loading = $state(false);

  onMount(() => {

  });

  function initPayment() {
    if (payment.amount === '' || payment.amount === '0') {
      return;
    }
    if (loading) {
      return;
    }
    selectedPaymentOption.fields.map((field) => {
      setValueToAdditionalFields(field);
    })
    loading = true
    paymentService.paymentInit(selectedPaymentOption.id, payment).then((res) => {
      if (res.data.status === 200) {
        if (res.data.data.action === 'REDIRECT') {
          window.location.href = res.data.data.url;
        } else if (res.data.data.action === 'FORM_SUBMIT') {
          let form = document.createElement('form');
          form.method = 'POST';
          form.action = res.data.data.url;
          Object.keys(res.data.data.formData).forEach((key) => {
            let input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = res.data.data.formData[key];
            form.appendChild(input);
          });
          document.body.appendChild(form);
          form.submit();
        }
      }
      console.log('init payment')
      loading = false;
    })
  }

  function setValueToAdditionalFields(field: any) {
    if (field === 'browserColorDepth') {
      payment.additionalFields[field.fieldName].value = window.screen.colorDepth;
    } else if (field === 'browserLanguage') {
      payment.additionalFields[field.fieldName].value = navigator.language;
    } else if (field === 'browserTimezone') {
      payment.additionalFields[field.fieldName].value = Intl.DateTimeFormat().resolvedOptions().timeZone;
    } else if (field === 'browserTimezoneOffset') {
      payment.additionalFields[field.fieldName].value = new Date().getTimezoneOffset();
    } else if (field === 'browserScreenHeight') {
      payment.additionalFields[field.fieldName].value = window.screen.height;
    } else if (field === 'browserScreenWidth') {
      payment.additionalFields[field.fieldName].value = window.screen.width;
    } else if (field === 'browserJavaScriptEnabled') {
      payment.additionalFields[field.fieldName].value = true;
    } else if (field === 'browserJavaEnabled') {
      payment.additionalFields[field.fieldName].value = false;
    } else if (field === 'browserAcceptHeader') {
      payment.additionalFields[field.fieldName].value = '';
    }
  }

</script>


<div class="flex justify-between text-xs w-full my-2 px-2">
  <span>You can only use your own payment account!</span>
  <span>Commission 0%</span>
</div>

<div class="w-full md:mt-2">
  <label class="text-sm text-primary-lightBlue ml-2" for="bankTransferAmount">Amount {#if selectedCurrency.minDepositAmount} (&euro;{selectedCurrency.minDepositAmount} - &euro;{selectedCurrency.maxDepositAmount}) {/if}</label>
  <input id="bankTransferAmount" bind:value={payment.amount} min="10" max="500" type="number" placeholder="Amount" class="w-full bg-primary-dark py-2 mt-2 px-5 rounded-full outline-0">
</div>
<div class="grid grid-cols-2 md:grid-cols-4 w-full gap-2.5 my-4">
  <button onclick={() => payment.amount = '50'} class="col-span-1 bg-primary-dark p-2 border-2 border-primary-lightBlue rounded-full text-sm font-thin" >
    50
  </button>
  <button onclick={() => payment.amount = '100'} class="col-span-1 bg-primary-dark p-2 border-2 border-primary-lightBlue rounded-full text-sm font-thin" >
    100
  </button>
  <button onclick={() => payment.amount = '200'} class="col-span-1 bg-primary-dark p-2 border-2 border-primary-lightBlue rounded-full text-sm font-thin" >
    200
  </button>
  <button onclick={() => payment.amount = '300'} class="col-span-1 bg-primary-dark p-2 border-2 border-primary-lightBlue rounded-full text-sm font-thin" >
    300
  </button>
</div>
<Button on:click={() => initPayment()} disabled={Number(payment.amount) < selectedCurrency.minDepositAmount || Number(payment.amount) > (selectedCurrency.maxDepositAmount ?? 1000000)} loading={loading} clas="w-full shadow-xl mt-3">Deposit</Button>

<div class="w-full">
  <BonusOffers type="FIAT" />
</div>
